import React from 'react';

export const PersonalizationIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.0001 9.16681C11.6109 9.16681 12.9167 7.86098 12.9167 6.25014C12.9167 4.6393 11.6109 3.33348 10.0001 3.33348C8.38925 3.33348 7.08341 4.6393 7.08341 6.25014C7.08341 7.86098 8.38925 9.16681 10.0001 9.16681Z"
      fill="currentColor"
    />
    <path
      d="M14.5834 13.3335C14.5834 11.2584 12.0751 10.0001 10.0001 10.0001C7.92508 10.0001 5.41675 11.2584 5.41675 13.3335V14.1668H14.5834V13.3335Z"
      fill="currentColor"
    />
    <path
      d="M16.6667 4.16681L15.8334 5.83348L14.1667 6.66681L15.8334 7.50014L16.6667 9.16681L17.5001 7.50014L19.1667 6.66681L17.5001 5.83348L16.6667 4.16681Z"
      fill="currentColor"
    />
  </svg>
);
